import React from 'react';
import { Flex } from '@mantine/core';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogBody from '~/domains/design-system/components/Dialog/DialogBody/DialogBody';
import dt from '~/testing';

import type { WelcomeModalProps } from './types';
import useStyles from './WelcomeModal.styles';

function WelcomeModal({
  isOpen,
  onClose,
  title,
  description,
  actionButtonText,
  onActionClick,
  headerContent,
  dataTestId = dt.common.components.welcomeModal.container,
}: WelcomeModalProps) {
  const { classes } = useStyles({ isCardsHidden: false });

  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      isOpen={isOpen}
      onClose={onClose}
      dataTestId={dataTestId}
    >
      <DialogBody className={classes.container}>
        {headerContent && <div className={classes.headerContent}>{headerContent}</div>}

        <Flex direction="column">
          <Title variant="headline-xl" className={classes.title} tag="h2">
            {title}
          </Title>

          <Text variant="body-large" className={classes.description} tag="p">
            {description}
          </Text>
        </Flex>

        <Button
          variant="primary-fill"
          size="large"
          className={classes.actionButton}
          onClick={onActionClick}
          data-test-id={`${dataTestId}-action-button`}
        >
          {actionButtonText}
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default WelcomeModal;
